module.exports = __webpack_public_path__ + "img/parking-lot-1.87a4f8e8.jpg";